import { LEGAL_LAST_UPDATED } from '@/constants/site.constants';
import { PRIVACY_CONTENT } from '@/features/legal/constants/privacy.constants';
import { useDocumentTitle } from '@/hooks/useDocumentTitle.hook';
import type { LegalDocumentContent } from '@/types/legal.types';

interface UsePolicyPageResult {
  content: LegalDocumentContent;
  lastUpdated: string;
}

export const usePolicyPage = (): UsePolicyPageResult => {
  useDocumentTitle(
    'Privacy Policy | Shoutt',
    'How Shoutt collects, uses, shares and protects the personal data of students using the app.',
  );

  return { content: PRIVACY_CONTENT, lastUpdated: LEGAL_LAST_UPDATED };
};
